module.exports = __webpack_public_path__ + "static/media/Physiofit-13.7fbf42a2.jpg";